export default __webpack_public_path__ + "static/media/expose2.8184c005.png";